import { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Masked line-by-line reveal — signature hero moment (animates on mount)
export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="reveal-mask">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.05, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

// Scroll-triggered masked reveal — observer on the visible mask wrapper (reliable)
export const RevealLine = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });
  return (
    <span ref={ref} className="reveal-mask">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={inView ? { y: "0%" } : { y: "110%" }}
        transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
};

// Fade + rise block reveal on scroll
export const Rise = ({ children, delay = 0, className = "", y = 40 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.2 });
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const SectionLabel = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs font-medium uppercase tracking-[0.25em] ${
      dark ? "text-vg-accent" : "text-vg-secondary"
    }`}
  >
    <span className={`h-px w-8 ${dark ? "bg-vg-accent" : "bg-vg-secondary"}`} />
    {children}
  </span>
);
